import React from "react";

import { Link } from "gatsby";

import ThemeSection from "components/Themes/Section/ThemeSection";

const ShopifySection: React.FC = () => (
    <div className="container mx-auto mb-20">
      <div className="mb-8 flex items-center justify-between">
        <h2 className="text-3xl font-bold text-gray-900">
          Exclusive Shopify Themes
        </h2>
        <Link to="/tag/shopify">
          <button className="btn-primary-outline">View all</button>
        </Link>
      </div>
      <div className="grid gap-8 lg:grid-cols-3 lg:gap-6">
        <ThemeSection tag={"Shopify"} limit={3} filterByBothTag={false} />
      </div>
    </div>
  );

export default ShopifySection;
